/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
async function initDUIL() {
    document.documentElement.style.setProperty("--dui-size-theme", String(16 / parseInt(getComputedStyle(document.documentElement).fontSize, 10)));
    if (!document.documentElement.getAttribute("dir")) {
        document.documentElement.setAttribute("dir", window.getComputedStyle(document.documentElement).direction);
    }
    if (!document.documentElement.getAttribute("lang")) {
        document.documentElement.setAttribute("lang", navigator.language || navigator.userLanguage);
    }
    if (!document.documentElement.getAttribute("data-dui-theme")) {
        document.documentElement.setAttribute("data-dui-theme", "theme-light");
    }
}

export { initDUIL as i };

//# sourceMappingURL=initDUIL-a7eb8edd.js.map